import useFormat from '../../hooks/useFormat';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

function LabelRow({ label, value }) {
    return (
        <div className="row p-10">
            <div className="col-md-1"></div>
            <div className="col-md-5 items-center">{label}</div>
            <div className="col-md-5 items-center">{value}</div>
            <div className="col-md-1"></div>
        </div>
    );
}

function ThankYouInvoiceView({ paymentData }) {
    const { formatPrice } = useFormat();
    const { data }        = paymentData || {};
    const bank_details    = data?.bank_details || [];

    //console.log(data);

    const loadBankDetails = () => (bank_data, key) => {

        return (    
            <div className="mt-20 mb-20 p-20  border border-gray-100 hover:border-main-600 rounded-16 max-w-[330px] flex flex-col justify-center items-center text-center mx-auto">  
                <div className='text-black text-md'>
                    <div className='d-flex flex-column justify-content-center align-items-center text-center'>
                        <div>
                            <div className="fw-semibold text-medium-electric-blue">Bank - {key+1}</div>
                            <div>{bank_data?.name}</div>
                        </div>

                        <div>
                            <div className="fw-semibold text-medium-electric-blue">Account </div>
                            <div>{bank_data?.account_number}</div>
                        </div>    

                        <div>
                            <div className="fw-semibold text-medium-electric-blue">Holder</div>
                            <div>{bank_data?.account_holder}</div>
                        </div>

                        <div>
                            <div className="fw-semibold text-medium-electric-blue">SWIFT</div>
                            <div>{bank_data?.swift}</div>
                        </div>

                        <div>
                            <div className="fw-semibold text-medium-electric-blue">IBAN</div>
                            <div>{bank_data?.iban}</div>
                        </div>
                    </div>
                </div>  
            </div>
        );
    };

    return (
        <div className="flex w-full flex-col items-center gap-y-5">
            <h3 className="text-center mt-20 p-5">Thank you!</h3>
            <h6 className="text-center mt-20 p-5">Your purchase is successfully completed.<br />Please deposit payment of {formatPrice(paymentData.total_amount_to_pay)} into our bank account using the references below.</h6>
            <div className='row'>
                <div className='col-md-4'></div>
                <div className='col-md-4'>
                    <div className="rounded bg-light-grey px-7 py-4">                  
                        {data?.reference_nr &&  <LabelRow label='Reference number:' value={data.reference_nr} />}
                        {data?.description && <LabelRow label='Description:' value={data.description} />}
                        {paymentData?.total_amount_to_pay && 
                            <LabelRow
                                label='Amount:'
                                value={formatPrice(paymentData?.total_amount_to_pay)}
                            />
                        }
                    </div>
                </div>
                <div className='col-md-4'></div>
            </div>
           
            <div> 
                {bank_details && bank_details.map( loadBankDetails() )}                         
            </div>
            <h6 className="text-center mt-20 p-5">
                All the details are also present in the order confirmation e-mail.
            </h6>            
            
            <div className="row mt-20 p-10">
                <div className="col-md-5"></div> 
                <div className="col-md-2">
                    <Link className="btn btn-main px-48" to='/'>
                        Back To E-shop
                    </Link>   
                </div> 
                <div className="col-md-5"></div> 
            </div>      
        </div>
    );
}

export default observer(ThankYouInvoiceView);
